import { call, put, takeEvery } from "redux-saga/effects";
import i18n from "i18next";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "./dpcProfilesGetActions";
import DOMPurify from "dompurify";

function* dpcProfilesGetSaga(action) {
  try {
    let response = yield call(
      requestWithSubTenantIfNeeded,
      "get",
      "dpc-controller/dpc-profile"
    );

    let { DPCProfiles, relationships } = response.data;

    relationships.relatedGroups.forEach((group) => {
      group.name = DOMPurify.sanitize(group.name);
    });

    DPCProfiles.forEach((profile) => {
      profile.name = DOMPurify.sanitize(profile.name);
      profile.rank = DPCProfiles.length - profile.position + 1;
      profile.assignedTo = profile.assignedTo.map(
        (groupId) =>
          relationships.relatedGroups.find((group) => group.id === groupId) || {
            id: groupId,
            objectId: groupId,
            name: i18n.t("common:NA"),
          }
      );
    });

    yield put(actions.requestSuccess(response.data));
  } catch (e) {
    yield put(actions.requestFailure(e));
  }
}

function* saga() {
  yield takeEvery(actions.DPC_PROFILES_GET_REQUEST, dpcProfilesGetSaga);
}

export default saga;
